import React from 'react';

import { inject, observer } from 'mobx-react';

@inject("rootStore")
@observer
class IstruzioniInvio extends React.Component {

  constructor(props) {
    super(props);
    this.tipoPratica = props.tipoPratica;
    this.qualificheStore = props.rootStore.qualificheStore;
    this.esitoContestuale = props.esitoContestuale;
  }

  componentDidMount() {
  }


  render() {

    const identificativoMnemonico = 'indicare nell’apposito campo l’identificativo mnemonico della pratica';
    const carica = 'Premere il tasto "Carica".';
    const verifica = 'Premere il tasto "Verifica" e attendere l\'esito dei controlli.';
    const invia = 'Premere il tasto "Invia".';
    const controlla = 'Premere il tasto "Controlla".';


    const istruzioni =

      <>
        {this.tipoPratica == 'MP' ?
          <div>
            <ul>
              <li>{identificativoMnemonico}</li>
              <li>seguire i seguenti passi:</li>
              <ol>
                <li>Selezionare il file contenente la “Domanda di Pegno” o il "Pagamento Integrativo".</li>
                <li>Selezionare il file contenete il “Titolo” (Obbligatorio se si sta presentando una "Domanda di Pegno").</li>
                <li>Selezionare il file contenente la "Procura" (solo se prevista).</li>
                <li>{carica}</li>
                <li>{verifica}</li>
                <li>{invia}</li>
              </ol>
            </ul>
          </div>

          : this.tipoPratica == 'UN' ?
          <div>
          <ul>
            {!this.qualificheStore.esitoContestuale&&<li>{identificativoMnemonico}</li>}
            {!this.qualificheStore.esitoContestuale&&<li>selezione il tipo di invio "in verifica"/"effettivo"</li>}
            <li>seguire i seguenti passi:</li>
            <ol>
              <li>Selezionare il file contenente l'Adempimento unico.</li>
              <li>{carica}</li>
              <li>{verifica}</li>
              {!this.qualificheStore.esitoContestuale&&<li>{invia}</li>}
              {this.qualificheStore.esitoContestuale&&<li>{controlla}</li>}
              
            </ol>
          </ul>
        </div>
          :this.tipoPratica == 'CP' ?
          <div>
            <ul>
              <li>{identificativoMnemonico}</li>
              <li>seguire i seguenti passi:</li>
              <ol>
                <li>Selezionare il file contenente la “Domanda di Certificato Pegno” .</li>
                
                <li>{carica}</li>
                <li>{verifica}</li>
                <li>{invia}</li>
              </ol>
            </ul>
          </div>
          : null
        }



      </>



    return (
      istruzioni

    );
  }
}

export default IstruzioniInvio;